<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pvEN4t/tc-custom/9780062265456.jpg?1720280630524" alt="This image is the cover for the book Healing Your Aloneness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Healing Your Aloneness
      </h1>
      <p class="bookDescription body article font2">
        <p>Erika Chopich and Margaret Paul show how anyone can reconnect with his or her Inner Child to short-circuit self-destructive patterns, resolve fears and conflicts, and build satisfying relationships. Healing Your Aloneness outlines a self-healing process that can be used every day to restore a nurturing balance between loving Adult and loved Inner Child.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Erika J. Chopich, Margaret Paul
      </h2>
      
      <p class="authorDescription body article"><P>Margaret Paul, Ph.D., is a psychotherapist and the coauthor of <I>Free to Love, Do l Have to Give Up Me to Be Loved By You?, From Conflict to Caring,</I> and <I>If You Really Loved Me.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9543d0b4